import {memo, ReactNode} from 'react';

import styled from 'styled-components';

import Button from '~/shared/components/Button';
import {smallRegular} from '~/shared/theme/typography';
import {rotateOnLTR} from '~/shared/theme/utils';

import ChevronLeft from './assets/chevronLeft.svg?react';

const Root = styled.div<{withBorderTop?: boolean}>`
  ${({withBorderTop}) => withBorderTop && 'border-top: 1px solid rgba(0, 0, 0, 0.08);'}
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CaptionButton = styled(Button)`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
`;

const Caption = styled.span`
  ${smallRegular}
  color: ${({theme}) => theme.colors.contentDefault};
`;

const StyledChevronLeft = styled(ChevronLeft)`
  ${rotateOnLTR}
`;

type ActionButtonProps = {
  caption: ReactNode;
  onClick?: () => void;
  className?: string;
  withBorderTop?: boolean;
  actionButton?: React.ReactNode;
};

const ActionButton = ({caption, onClick, className, withBorderTop, actionButton}: ActionButtonProps) => {
  return (
    <Root className={className} withBorderTop={withBorderTop}>
      <CaptionButton onClick={onClick}>
        <Caption>{caption}</Caption>
        {!actionButton && <StyledChevronLeft />}
      </CaptionButton>
      {actionButton}
    </Root>
  );
};

export default memo(ActionButton);
